export type SupportPanelBrand = "etb" | "flow";

export function supportPanelBrand(brandId: string): SupportPanelBrand {
  return brandId === "etb" ? "etb" : "flow";
}
